import { useQuery } from '@apollo/client/react';

import { listUsersQuery } from '../../services/UserService';

export const useUsers = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listUsersQuery, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { users: data?.users || [], loading, error };
};
